// Constantes para Níveis dos rios e arroios

export type FluviometricPost = {
  title: string;
  description?: string;
  image?: string;
  alt?: string;
  link?: string;
  embedUrl?: string;
  source?: string;
  status?: string;
};

export type FluviometricPostGroup = {
  title: string;
  eyebrow: string;
  description: string;
  posts: FluviometricPost[];
};

export const fluviometricMap: FluviometricPost = {
  title: 'Mapa de localização das réguas de nível',
  description:
    'Consulte no mapa a distribuição das réguas linimétricas instaladas em Rolante/RS.',
  image: '/images/postos-fluviometricos/mapa.jpg',
  alt: 'Mapa de localização das réguas de nível',
  link: 'https://www.google.com/maps/d/u/1/edit?mid=1fhvfJDE1PWOAjfJ3GlXOKNC3dHcpKGk&usp=sharing',
};

export const fluviometricPostGroups: FluviometricPostGroup[] = [
  {
    title: 'Câmeras de videomonitoramento',
    eyebrow: 'Monitoramento',
    description:
      'Pontos com acompanhamento por câmera para apoiar a leitura visual das condições dos rios e arroios.',
    posts: [
      {
        title: 'Câmera de videomonitoramento',
        description:
          'Bairro Grassmann - Rolante/RS\nCota de inundação: 3,5 metros',
        image: '/images/postos-fluviometricos/bairro_grassmann.jpeg',
        alt: 'Visualização do rio no Bairro Grassmann - Rolante/RS',
        link: 'https://rolante.solutti.net/rioareia/',
        embedUrl:
          'https://rolante.solutti.net/rioareia/?controls=0&muted=1&autoplay=1&playsinline=1',
        status: 'Ao vivo',
        source: 'Observatório Heller & Jung.',
      },
      {
        title: 'Câmera de videomonitoramento',
        description:
          'Mata Olho - Rolante/RS\nCota de alerta para o Bairro Grassmann: 2,6 metros',
        alt: 'Visualização do rio no Mata Olho - Rolante/RS',
        link: 'https://rolante.solutti.net/pontemataolho/',
        embedUrl:
          'https://rolante.solutti.net/pontemataolho/?controls=0&muted=1&autoplay=1&playsinline=1',
        status: 'Ao vivo',
        source: 'Observatório Heller & Jung.',
      },
    ],
  },
  {
    title: 'Sensores de nível por radar',
    eyebrow: 'Leitura automatizada',
    description:
      'Sensores e sistemas digitais que disponibilizam medições de nível dos cursos d’água.',
    posts: [
      {
        title: 'Alto Rolante – Rolante/RS',
        image: '/images/postos-fluviometricos/alto_rolante_sensores.jpeg',
        alt: 'Alto Rolante – Rolante/RS',
        link: 'https://clima.rs.gov.br/',
        source: 'Secretaria do Meio Ambiente e Infraestrutura (SEMA).',
      },
      {
        title: 'Mascarada - Rolante/RS',
        description: 'Altitude de inundação: 88,2 metros',
        image: '/images/postos-fluviometricos/new_mascarada.jpeg',
        alt: 'Mascarada - Rolante/RS',
        link: 'https://redehidrometeorologica.defesacivil.rs.gov.br/Estacao/DCRS-00005',
        source: 'Defesa Civil Estadual.',
      },
      {
        title: 'Rolantinho - Rolante/RS',
        image: '/images/postos-fluviometricos/new_rolantinho.jpeg',
        alt: 'Rolantinho - Rolante/RS',
        link: 'https://redehidrometeorologica.defesacivil.rs.gov.br/Estacao/DCRS-00006',
        source: 'Defesa Civil Estadual.',
      },
    ],
  },
  {
    title: 'Réguas de nível',
    eyebrow: 'Referência local',
    description:
      'Réguas linimétricas usadas como referência visual para acompanhar a elevação dos rios e arroios.',
    posts: [
      {
        title: 'Alto Rolante - Rolante/RS',
        image: '/images/postos-fluviometricos/alto_rolante.jpeg',
        alt: 'Alto Rolante - Rolante/RS',
        link: '/images/postos-fluviometricos/alto_rolante.jpeg',
      },
      {
        title: 'Bairro Grassmann - Rolante/RS',
        description: 'Cota de inundação: 3,5 metros',
        image: '/images/postos-fluviometricos/bairro_grassmann.jpeg',
        alt: 'Bairro Grassmann - Rolante/RS',
        link: '/images/postos-fluviometricos/bairro_grassmann.jpeg',
      },
      {
        title: 'Linha Petry - Rolante/RS',
        image: '/images/postos-fluviometricos/linha_petry.jpeg',
        alt: 'Linha Petry - Rolante/RS',
        link: '/images/postos-fluviometricos/linha_petry.jpeg',
      },
      {
        title: 'Mascarada - Rolante/RS',
        image: '/images/postos-fluviometricos/mascarada.jpeg',
        alt: 'Mascarada - Rolante/RS',
        link: '/images/postos-fluviometricos/mascarada.jpeg',
      },
      {
        title: 'Mata Olho - Rolante/RS',
        image: '/images/postos-fluviometricos/mata_olho.jpeg',
        alt: 'Mata Olho - Rolante/RS',
        link: '/images/postos-fluviometricos/mata_olho.jpeg',
      },
      {
        title: 'Praça da Matriz - Rolante/RS',
        image: '/images/postos-fluviometricos/praca_matriz.jpeg',
        alt: 'Praça da Matriz - Rolante/RS',
        link: '/images/postos-fluviometricos/praca_matriz.jpeg',
      },
    ],
  },
];
